import { monixAxios } from "@/declare/api/axios"
import { MonitorObjectPrimitive } from "../interface/primitive"
import { AxiosResponse } from "axios"
import qs from 'qs';

/**
 * 通过监测项目ID获取关联表列表
 * @param projectId 
 * @param params 
 * @returns 
 */
export function findMonitorObjectPrimitiveByProjectId(projectId: number, params?: {}): Promise<AxiosResponse<any>> {
    return monixAxios.get(`/projects/${projectId}/monitor-object-primitive`, {
        params: {
            ...params,
        }
    })
}

/**
 * 新建监测数据与图元的关联信息，仅添加一条
 * @param projectId 
 * @param monitorObjectId 
 * @param primitiveUuid 
 * @param params 
 * @returns 
 */
export function addMonitorObjectPrimitive(projectId: number, monitorObjectId: number, primitiveUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return monixAxios.post(`/projects/${projectId}/monitorObject/${monitorObjectId}/primitive/${primitiveUuid}/monitor-object-primitive`, null, {
        params: {
            ...params,
        }
    })
}

/**
 * 新建监测数据与图元的关联信息，添加多条
 * @param projectId 
 * @param data 
 * @param params 
 * @returns 
 */
export function addMonitorObjectPrimitives(projectId: number, data: MonitorObjectPrimitive[], params?: {}): Promise<AxiosResponse<any>> {
    return monixAxios.post(`/projects/${projectId}/monitor-object-primitive`, data, {
        params: {
            ...params,
        }
    })
}

/**
 * 更新监测数据与图元的关联信息
 * @param primitiveUuid 
 * @param data 
 * @param params 
 * @returns 
 */
export function updateMonitorObjectPrimitive(primitiveUuid: string, data: MonitorObjectPrimitive, params?: {}): Promise<AxiosResponse<any>> {
    return monixAxios.put(`/monitor-object-primitive/${primitiveUuid}`, data, {
        params: {
            ...params,
        }
    })
}

/**
 * 删除监测数据与图元的关联信息
 * @param primitiveUuid 
 * @param params 
 * @returns 
 */
export function deleteMonitorObjectPrimitive(primitiveUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return monixAxios.delete(`/monitor-object-primitive/${primitiveUuid}`, {
        params: {
            ...params,
        }
    })
}

/**
 * 根据 params 里面的 project_id 查询监测对象
 * @param params 
 * @returns 
 */
export function queryMobjects(params: {}): Promise<AxiosResponse<any>> {
    return monixAxios.get(`/mobjects`, {
        params: params
    })
}

// 获取已经创建并激活的group列表
export function queryQuantityGroups(mobjectId: number, params?: {}): Promise<AxiosResponse<any>> {
    return monixAxios.get(`/mobjects/${mobjectId}/quantity-groups`, {
        params: params
    })
}

// 获取已经创建并激活的group列表
export function queryQuantityGroupsMulti(mobjectIds: number[], params?: {}): Promise<AxiosResponse<any>> {
    return monixAxios.post(`/mobjects/quantity-groups/multi-get`, mobjectIds, {
        params: params
    })
}

// 获取当前监测项目中的全局指标
export function queryProjectGlobalQuantities(projectId: number, params?: {}): Promise<AxiosResponse<any>> {
    return monixAxios.get(`/projects/${projectId}/global-quantities`, {
        params: params
    })
}

// 获取当前监测项目中的指标
export function queryQuantities(projectId: number, params?: {}): Promise<AxiosResponse<any>> {
    return monixAxios.get(`/projects/${projectId}/quantities`, {
        params: params
    })
}

// 获取当前监测项目中的指标
export function queryQuantitiesMulti(projectId: number, paramsList: any[], params?: {}): Promise<AxiosResponse<any>> {
    return monixAxios.post(`/projects/${projectId}/quantities/multi-get`, paramsList, {
        params: params
    })
}

// 获取指标数据详情
export function queryQuantityData(quantityId: number, params?: {}): Promise<AxiosResponse<any>> {
    return monixAxios.get(`/quantities/${quantityId}/data`, {
        params: params
    })
}

// 获取当前指标数据
export function queryQuantityCurrentDataListGet(params?: {}): Promise<AxiosResponse<any>> {
    return monixAxios.get(`/quantities/data/current`, {
        params: params,
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

// 获取当前指标数据
export function queryQuantityCurrentDataList(quantityIds: any[]): Promise<AxiosResponse<any>> {
    return monixAxios.post(`/quantities/data/current`, { quantity_ids: quantityIds }, {})
}

// 查询监测对象详情
export function queryMobjectDetail(mobjectId: number, params?: {}): Promise<AxiosResponse<any>> {
    return monixAxios.get(`/mobjects/${mobjectId}`, {
        params: params
    })
}

// 查询设备列表（采集箱）
export function queryDboxs(params: {}): Promise<AxiosResponse<any>> {
    return monixAxios.get(`/dboxs`, {
        params: params
    })
}
// 查询设备列表（传感器）
export function querySensors(params: {}): Promise<AxiosResponse<any>> {
    return monixAxios.get(`/sensors`, {
        params: params
    })
}
// 获取项目中指标最严重的评估等级，map结构 key为类型 结构、构件... value为等级
export function getProjectRankGroup(projectId: number, params?: {}): Promise<AxiosResponse<any>> {
    return monixAxios.get(`/projects/${projectId}/rank-Group`, {
        params: params
    })
}
/**
 * 根据 params 里面的 project_id 查询监测对象,返回值里含报警等级
 * @param params 
 * @returns 
 */
export function queryMobjectsByWarningLevel(params: {}): Promise<AxiosResponse<any>> {
    return monixAxios.get(`/mobjects/warning`, {
        params: params
    })
}
